.header_CaptureAdminEmail_13161b3{display:flex;flex-direction:column;row-gap:1em}